import { lazy } from "react";

const ProjectList = lazy(() =>
  import("./ProjectList").then((m) => ({ default: m.ProjectList })),
);
const ProjectCreate = lazy(() =>
  import("./ProjectCreate").then((m) => ({ default: m.ProjectCreate })),
);
const ProjectEdit = lazy(() =>
  import("./ProjectEdit").then((m) => ({ default: m.ProjectEdit })),
);
const ProjectShow = lazy(() =>
  import("./ProjectShow").then((m) => ({ default: m.ProjectShow })),
);

export default {
  list: ProjectList,
  create: ProjectCreate,
  edit: ProjectEdit,
  show: ProjectShow,
  recordRepresentation: "name",
};
